import React from "react";

const Door = () => {
    return (
        <svg width="143" height="78" viewBox="0 0 143 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3598_36014)">
                <path d="M9.16319 0.169922H4.59375V76.3799H9.16319V0.169922Z" fill="#4A5353" />
                <path d="M71.5014 66.3803C71.5014 29.8142 41.5449 0.169922 4.59375 0.169922" stroke="#4A5353" stroke-width="0.6" stroke-miterlimit="10" />
                <path d="M133.837 76.3809H138.406V0.17086H133.837V76.3809Z" fill="#4A5353" />
                <path d="M71.5 66.3803C71.5 29.8142 101.457 0.169922 138.408 0.169922" stroke="#4A5353" stroke-width="0.6" stroke-miterlimit="10" />
            </g>
            <defs>
                <clipPath id="clip0_3598_36014">
                    <rect width="143" height="78" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
export default Door;